import { createSlice } from "@reduxjs/toolkit";

export default createSlice({
    name: "report",
    initialState: null,
    reducers: {
        set: (state, action) => action.payload,
    },
});
